import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Button from '../components/Button';
import { PhoneIcon, MailIcon, MapPinIcon, SendIcon, SparklesIcon, MessageCircleIcon } from 'lucide-react';
const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    // Simulate form submission
    setTimeout(() => {
      setIsSubmitting(false);
      setSubmitStatus('success');
      setFormData({
        name: '',
        email: '',
        phone: '',
        message: ''
      });
      setTimeout(() => {
        setSubmitStatus('idle');
      }, 3000);
    }, 1500);
  };
  return <section className="min-h-screen bg-gray-900 relative overflow-hidden py-20" data-id="element-171">
      {/* Background effects */}
      <div className="absolute inset-0 opacity-10" data-id="element-172">
        <div className="absolute top-0 right-0 w-96 h-96 bg-purple-500 rounded-full blur-3xl" data-id="element-173"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-pink-500 rounded-full blur-3xl" data-id="element-174"></div>
      </div>
      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-175">
        {/* Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-176">
          <h1 className="text-4xl md:text-6xl font-bold mb-6 text-white" data-id="element-177">
            Hablemos de tu{' '}
            <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent" data-id="element-178">
              próximo proyecto
            </span>
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-179">
            Estamos listos para transformar tu visión en realidad. Contáctanos y
            descubre cómo podemos proyectar la grandeza de tu marca.
          </p>
        </motion.div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-180">
          {/* Contact Form */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8
        }} viewport={{
          once: true
        }} className="bg-gradient-to-br from-gray-800 to-gray-900 p-8 rounded-2xl border border-purple-500/20" data-id="element-181">
            <form onSubmit={handleSubmit} className="space-y-6" data-id="element-182">
              <div data-id="element-183">
                <label htmlFor="name" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-184">
                  Nombre completo
                </label>
                <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required className="w-full px-4 py-3 bg-gray-700 text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 border border-gray-600" placeholder="Tu nombre" data-id="element-185" />
              </div>
              <div data-id="element-186">
                <label htmlFor="email" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-187">
                  Correo electrónico
                </label>
                <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required className="w-full px-4 py-3 bg-gray-700 text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 border border-gray-600" placeholder="tu@email.com" data-id="element-188" />
              </div>
              <div data-id="element-189">
                <label htmlFor="phone" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-190">
                  Teléfono
                </label>
                <input type="tel" id="phone" name="phone" value={formData.phone} onChange={handleChange} className="w-full px-4 py-3 bg-gray-700 text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 border border-gray-600" placeholder="+502 1234-5678" data-id="element-191" />
              </div>
              <div data-id="element-192">
                <label htmlFor="message" className="block text-sm font-medium text-gray-300 mb-2" data-id="element-193">
                  Mensaje
                </label>
                <textarea id="message" name="message" value={formData.message} onChange={handleChange} required rows={5} className="w-full px-4 py-3 bg-gray-700 text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 border border-gray-600 resize-none" placeholder="Cuéntanos sobre tu proyecto..." data-id="element-194" />
              </div>
              <button type="submit" disabled={isSubmitting} className="w-full bg-gradient-to-r from-purple-600 to-pink-600 text-white py-3 rounded-lg font-semibold hover:from-purple-700 hover:to-pink-700 disabled:opacity-50 disabled:cursor-not-allowed transition-all flex items-center justify-center gap-2" data-id="element-195">
                {isSubmitting ? <>
                    <SparklesIcon className="h-5 w-5 animate-spin" data-id="element-196" />
                    Enviando...
                  </> : <>
                    <SendIcon className="h-5 w-5" data-id="element-197" />
                    Enviar mensaje
                  </>}
              </button>
              {submitStatus === 'success' && <motion.div initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} className="bg-green-500/20 border border-green-500/50 text-green-300 px-4 py-3 rounded-lg text-center" data-id="element-198">
                  ¡Mensaje enviado con éxito! Nos pondremos en contacto pronto.
                </motion.div>}
            </form>
          </motion.div>
          {/* Contact Info */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8
        }} viewport={{
          once: true
        }} className="space-y-8" data-id="element-199">
            <div data-id="element-200">
              <h2 className="text-3xl font-bold mb-6 text-white" data-id="element-201">
                Información de{' '}
                <span className="bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent" data-id="element-202">
                  contacto
                </span>
              </h2>
              <p className="text-lg text-gray-300 mb-8" data-id="element-203">
                También puedes contactarnos directamente a través de los
                siguientes medios:
              </p>
            </div>
            <div className="space-y-6" data-id="element-204">
              {/* Phone with WhatsApp */}
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5,
              delay: 0.1
            }} viewport={{
              once: true
            }} className="flex items-start bg-gradient-to-br from-gray-800 to-gray-900 p-6 rounded-xl border border-purple-500/20 hover:border-purple-500/40 transition-all duration-300 group" data-id="element-205">
                <div className="bg-purple-500/20 p-3 rounded-lg mr-4 group-hover:scale-110 transition-transform duration-300" data-id="element-206">
                  <PhoneIcon className="h-6 w-6 text-purple-400" data-id="element-207" />
                </div>
                <div className="flex-1" data-id="element-208">
                  <h3 className="font-semibold text-lg text-white mb-1" data-id="element-209">
                    Teléfono
                  </h3>
                  <p className="text-gray-300 mb-3" data-id="element-210">+502 4693-3600</p>
                  <a href="https://wa.me/50246933600" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 bg-gradient-to-r from-green-600 to-green-500 hover:from-green-700 hover:to-green-600 text-white px-4 py-2 rounded-lg transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-green-500/50" data-id="element-211">
                    <MessageCircleIcon className="h-4 w-4" data-id="element-212" />
                    <span className="font-semibold text-sm" data-id="element-213">
                      Chatear por WhatsApp
                    </span>
                  </a>
                </div>
              </motion.div>
              {/* Email */}
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5,
              delay: 0.2
            }} viewport={{
              once: true
            }} className="flex items-start bg-gradient-to-br from-gray-800 to-gray-900 p-6 rounded-xl border border-purple-500/20 hover:border-purple-500/40 transition-all duration-300 group" data-id="element-214">
                <div className="bg-purple-500/20 p-3 rounded-lg mr-4 group-hover:scale-110 transition-transform duration-300" data-id="element-215">
                  <MailIcon className="h-6 w-6 text-purple-400" data-id="element-216" />
                </div>
                <div data-id="element-217">
                  <h3 className="font-semibold text-lg text-white mb-1" data-id="element-218">
                    Email
                  </h3>
                  <a href="mailto:info@gruporeflex.com" className="text-gray-300 hover:text-purple-400 transition-colors" data-id="element-219">
                    info@gruporeflex.com
                  </a>
                </div>
              </motion.div>
              {/* Location */}
              <motion.div initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 0.5,
              delay: 0.3
            }} viewport={{
              once: true
            }} className="flex items-start bg-gradient-to-br from-gray-800 to-gray-900 p-6 rounded-xl border border-purple-500/20 hover:border-purple-500/40 transition-all duration-300 group" data-id="element-220">
                <div className="bg-purple-500/20 p-3 rounded-lg mr-4 group-hover:scale-110 transition-transform duration-300" data-id="element-221">
                  <MapPinIcon className="h-6 w-6 text-purple-400" data-id="element-222" />
                </div>
                <div data-id="element-223">
                  <h3 className="font-semibold text-lg text-white mb-1" data-id="element-224">
                    Ubicación
                  </h3>
                  <p className="text-gray-300" data-id="element-225">
                    Ciudad de Guatemala, Guatemala
                  </p>
                </div>
              </motion.div>
            </div>
            {/* Hours */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.4
          }} viewport={{
            once: true
          }} className="bg-gradient-to-br from-gray-800 to-gray-900 p-6 rounded-xl border border-purple-500/20" data-id="element-226">
              <h3 className="font-semibold text-lg text-white mb-4" data-id="element-227">
                Horarios de atención
              </h3>
              <div className="space-y-2 text-gray-300" data-id="element-228">
                <p data-id="element-229">Lunes a Viernes: 9:00 AM - 6:00 PM</p>
                <p data-id="element-230">Sábados: 9:00 AM - 1:00 PM</p>
                <p data-id="element-231">Domingos: Cerrado</p>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
};
export default Contact;